import React from 'react'
import { Button, Grid, Typography } from '@material-ui/core'
import HighlightOffIcon from '@material-ui/icons/HighlightOff'

export const OperacionesMovimientosView = ({
  silo: { nombreCorto, estado, fechaDeVaciado },
  openDialogInicioLlenado,
  openDialogModificarInicioLlenado,
  openDialogFinLlenado,
  openDialogVaciado,
  openDialogEliminarVaciado,
  openDialogEliminarInicioLlenado,
  openDialogEliminarFinLlenado,
  cancelar
}) => (
  <Grid container direction='column' justify='space-around' spacing={2} alignItems='center'>
    <Grid item>
      <Typography variant='h6'>Movimientos disponibles para silo <strong>{nombreCorto}</strong></Typography>
    </Grid>
    {(estado === 'V' || estado === null) && (
      <Grid item>
        <Button
          variant='contained'
          onClick={openDialogInicioLlenado}>
          INICIO LLENADO
        </Button>
      </Grid>
    )}
    {(estado === 'V' || estado === null) && fechaDeVaciado !== null && (
      <Grid item>
        <Button
          variant='contained'
          onClick={openDialogEliminarVaciado}>
          ELIMINAR ULTIMO VACIADO
        </Button>
      </Grid>
    )}
    {estado === 'U' && (
      <>
        <Grid item>
          <Button
            variant='contained'
            onClick={openDialogModificarInicioLlenado}>
            MODIFICAR LLENADO
          </Button>
        </Grid>
        <Grid item>
          <Button
            variant='contained'
            onClick={openDialogFinLlenado}>
            FINALIZAR LLENADO
          </Button>
        </Grid>
        <Grid item>
          <Button
            variant='contained'
            onClick={openDialogEliminarInicioLlenado}>
            ELIMINAR INICIO DE LLENADO
          </Button>
        </Grid>
      </>
    )}
    {estado === 'L' && (
      <>
        <Grid item>
          <Button
            variant='contained'
            onClick={openDialogVaciado}>
            VACIAR SILO
          </Button>
        </Grid>
        <Grid item>
          <Button
            variant='contained'
            onClick={openDialogEliminarFinLlenado}>
            ELIMINAR FIN DE LLENADO
          </Button>
        </Grid>
      </>
    )}
    <Grid container item spacing={2} justify='flex-end'>
      <Grid item xs='auto'>
        <Button
          color='primary'
          variant='contained'
          startIcon={<HighlightOffIcon />}
          onClick={cancelar}>
          Cerrar
        </Button>
      </Grid>
    </Grid>
  </Grid>
)
